import React from 'react';
import FoodConceptImage from '../assets/images/Group 42348.png';
import VendorImage from '../assets/images/Invoice image.png';
import GroupImages from '../assets/images/image 6.png';

const AuthenticationPages = ({ FormTitle, children, formtext }) => {
  return (
    <div className='min-h-screen w-full bg-gray-50'>
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        
        {/* Right Column - Form Section */}
        <div className="flex flex-col bg-white order-1 lg:order-2">
          {/* Header with Logo */}
          <header className="flex-shrink-0 p-4 sm:p-6 lg:p-8">
            <img 
              className='h-16 sm:h-20 lg:h-24 object-contain' 
              src={FoodConceptImage} 
              alt="Food Concepts Logo" 
            />
          </header>

          {/* Main Form Content */}
          <main className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-8 py-8">
            <div className="w-full max-w-md mx-auto space-y-6">
              <div className="text-center sm:text-left">
                <h1 className='text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight'>
                  {FormTitle}
                </h1>
                <p className='mt-3 text-base sm:text-lg text-gray-600 leading-relaxed'>
                  {formtext}
                </p>
              </div>
              
              {/* Form Content */}
              <div className="mt-8">
                {children}
              </div>
            </div>
          </main>

          {/* Mobile Bottom Image */}
          <div className="flex-shrink-0 lg:hidden">
            <img 
              className='w-full h-24 sm:h-32 object-cover px-4' 
              src={GroupImages} 
              alt="Decorative footer" 
            />
          </div>

          {/* Footer */}
          <footer className="flex-shrink-0 p-4 sm:p-6 lg:p-8 mx-auto">
            <div className="flex flex-col sm:flex-row items-center justify-center  gap-2 sm:gap-4 text-sm text-gray-500">
              <span>Copyright ©2024</span>
              <span className='hidden sm:inline border-l border-gray-300 pl-4'>Food Concepts</span>
              <span className='sm:hidden'>Food Concepts</span>
              <span className='hidden sm:inline border-l border-gray-300 pl-4'>All rights reserved</span>
              <span className='sm:hidden'>All rights reserved</span>
            </div>
          </footer>
        </div>

        {/* Left Column - Image Section */}
        <div className="hidden lg:flex flex-col bg-gradient-to-br from-blue-50 to-indigo-100 order-2 lg:order-1">
          {/* Main Vendor Image */}
          <div className="flex-1 flex items-center justify-center p-8 lg:p-12">
            <div className="relative max-w-lg w-full">
              <img 
                className='w-full h-auto object-contain drop-shadow-2xl' 
                src={VendorImage} 
                alt="Vendor Invoice Management" 
              />
              {/* Optional overlay for better visual hierarchy */}
              <div className="absolute -inset-4 bg-white/20 rounded-3xl -z-10 backdrop-blur-sm"></div>
            </div>
          </div>
          
          {/* Bottom Decorative Image */}
          <div className="flex-shrink-0 flex justify-center pb-8">
            <img 
              className='h-20 lg:h-24 object-contain opacity-80' 
              src={GroupImages} 
              alt="Decorative elements" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthenticationPages;